import { render, staticRenderFns } from "./HomeCurrentPage.vue?vue&type=template&id=cc962988&scoped=true"
import script from "./HomeCurrentPage.vue?vue&type=script&lang=js"
export * from "./HomeCurrentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc962988",
  null
  
)

export default component.exports